module.exports = __webpack_public_path__ + "static/media/3-KNAIN.98d5952b.mp3";